import { ChartBarIcon, TrashIcon } from '@heroicons/react/24/solid'
import { useDataProvider } from 'ra-core'
import { useMemo } from 'react'

import { useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'
import { WidgetPayload } from '../types'
import { SectionTitle } from '../components/Title'

import { CustomChart } from './charts/CustomChart'
import { dataTypes, parseCustomChart } from '../components/customCharts/helpers'

export const CustomChartSection = ({ widget }: { widget: WidgetPayload }) => {
  const dp = useDataProvider()
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const onDelete = () => {
    dp.removeWidget(widget.id).then(() => {
      queryClient.invalidateQueries('widgets')
    })
  }

  const customValue = useMemo(
    () => parseCustomChart(widget.custom_value ?? ''),
    [widget.custom_value]
  )

  const dt =
    dataTypes.find((d) => d.id === customValue.dataType) ?? dataTypes[0]

  return (
    <div className="space-y-6 group">
      <div className="flex items-start justify-between">
        <SectionTitle title={widget.name} subtitle={widget.description} />
        <div className="flex items-start justify-end gap-2">
          <div className="py-1.5 px-3 rounded-md border text-xs divide-x flex items-center text-gray-600 bg-white shadow-sm">
            <span className="pr-2">
              {customValue.chartType === 'line' ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-3.5"
                >
                  <path d="M3 3v18h18" />
                  <path d="m19 9-5 5-4-4-3 3" />
                </svg>
              ) : (
                <ChartBarIcon className="h-3.5" />
              )}
            </span>
            <span className="pl-2">{t(dt.nameKey)}</span>
          </div>
          <button
            type="button"
            onClick={onDelete}
            className="opacity-0 w-0 group-hover/widget:w-auto group-hover/widget:opacity-100 p-2 rounded-lg bg-red-500 hover:bg-opacity-80 text-white"
          >
            <TrashIcon className="h-4" />
          </button>
        </div>
      </div>
      <CustomChart chart={customValue} />
    </div>
  )
}
